import {
  selectSkipState,
  setSkipState,
} from '@/src/store/slices/sportsV2Slice.ts'
import { store } from '@/src/store/store.tsx'

const scrollTopOfFrame = () => {
  window.scrollTo(0, 0)
}

export const hasAltenarV2 = () => window.AltenarSportsbook !== undefined

// Helper functions before init sports book START
export const additionalParamsStrV2 = () => {
  const additionalParamsSTR = window.location.href.split('?')[1]

  if (additionalParamsSTR === undefined) {
    return ''
  }
  return `&${additionalParamsSTR}`
}

function buildQueryParams(params: Record<string, string>): string {
  return Object.keys(params)
    .map((key) => {
      const value = params[key]
      if (value === null || value === undefined) {
        return ''
      }
      if (Array.isArray(value)) {
        return value
          .map(
            (arrayValue) =>
              `${encodeURIComponent(key)}=${encodeURIComponent(arrayValue)}`,
          )
          .join('&')
      }
      return `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
    })
    .filter((param) => param.length > 0)
    .join('&')
}

export const initAltenarV2 = (initParams: Record<string, unknown>) => {
  const _initParams = {
    fixedTop: 100,
    fixedBottom: 1,
    isHashMode: false,
    intervalDelay: 100,
    stateChangeCallback: function (parameters) {
      if (!selectSkipState(store.getState())) {
        window.history.pushState(null, '', `?${buildQueryParams(parameters)}`)
      }
      scrollTopOfFrame()
      store.dispatch(setSkipState(false))
    },
    placebetcallback: scrollTopOfFrame,
    betreservationcallback: scrollTopOfFrame,
  }

  return new window.AltenarSportsbook('#altenarsportsbook', {
    ...initParams,
    ..._initParams,
  })
}
